export default {
  getOffersSelectedsDiscountsByKey({ state }, key) {
    let discounts = []
    state.offersSelecteds.forEach(offer => {
      if (offer?.discounts?.[key]?.length) {
        discounts = [...discounts, ...offer?.discounts?.[key]]
      }
    });

    return discounts
  },
  async getOffersSelectedsDiscountValueByKey({ dispatch }, key) {
    const discounts = await dispatch('getOffersSelectedsDiscountsByKey', key)
    
    return discounts?.reduce((acc, d) => {
      if (acc[d.type] === undefined) {
        acc[d.type] = 0
      }
      acc[d.type] += d.value;
      
      return acc
    }, {})
  }
}
